import { createRestClient } from 'web-app/api/clients/rest-client';
import { APIErrorCode } from '@famly/vet_api-error-codes';
import { logOut } from 'signin-app/login/actions';
import APIHelper from 'signin-app/api/helpers/api-helper';
import { withKioskLocale } from './with-kiosk-locale';
const onError = (errorMessage) => {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.log(errorMessage);
    }
};
const senryService = {
    // eslint-disable-next-line no-console
    captureMessage: (message) => console.log(message),
    // eslint-disable-next-line no-console
    captureException: (e) => console.log(e),
};
const SignInAppRestClient = createRestClient(APIHelper, onError, senryService, [], withKioskLocale);
let errorSubscription;
// Handles expired login session
if (!errorSubscription) {
    errorSubscription = SignInAppRestClient.ErrorSubject.subscribe(error => {
        if (error.responseData && error.responseData.errorCode === APIErrorCode.SESSION_EXPIRED) {
            logOut.dispatch(false);
        }
    });
}
export default SignInAppRestClient;
